module.exports = __webpack_public_path__ + "static/media/googleplay.445ecd84.png";